import React from 'react';
import Navbar from '../components/Navbar';

const AboutUs = () => {
    return (
        <div className="min-h-screen">
            <Navbar />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white/90 backdrop-blur-sm rounded-lg shadow-xl p-8 md:p-12">
                    {/* Header Section */}
                    <div className="text-center mb-12">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            About GoodBuyTamizha
                        </h1>
                        <p className="text-xl text-blue-600 font-semibold">
                            Global Tamil Business E-Commerce Platform
                        </p>
                    </div>

                    {/* Intro Section */}
                    <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
                        <p className="lead text-xl font-medium">
                            A Tamil Business E-Commerce Website & Mobile Application
                        </p>
                        <p>
                            This is an integrated digital business platform created for Tamil entrepreneurs and those seeking business services across all countries where Tamils reside globally.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                            A Digital Continuation of Tamil Trade Heritage
                        </h2>
                        <p>
                            In the ancient Tamil civilization, trade was not just a profession; it was the culture, economy, and identity of the Tamil people. The Chera, Chola, and Pandya kings crossed oceans to trade, spreading Tamil commerce worldwide and expanding their influence through maritime excellence.
                        </p>
                        <p>
                            During that era, specialized titles were given to sea traders, grain merchants, and small-to-large scale business owners. They lived as an organized business community with dedicated trade meetings and federations.
                        </p>
                        <p>
                            As a continuation of that historical pride, <strong>GoodBuyTamizha.com</strong> is an initiative to connect globally dispersed Tamils through trade, services, production, and shared needs on a single digital platform.
                        </p>
                        <p>
                            Whether it is a merchant, a service provider, a manufacturer, or a business consumer—this platform is designed to serve everyone, regardless of which country they live in.
                        </p>

                        {/* Verified Platform Section */}
                        <div className="bg-blue-50 p-6 rounded-lg my-8 border-l-4 border-blue-600">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-0">
                                Verified Tamil Business Platform – For Global Tamils
                            </h2>
                            <p className="mb-4">
                                GoodBuyTamizha acts as a Verified Tamil Business Platform that directly connects global customers with Tamil entrepreneurs and organizations offering:
                            </p>
                            <ul className="list-disc pl-5 space-y-2">
                                <li>Women's Self-Help Group (SHG) products.</li>
                                <li>Government-certified home-made handicrafts.</li>
                                <li>Food products and supplements.</li>
                                <li>Small, micro, and cottage industry goods.</li>
                                <li>B2B & B2C services.</li>
                            </ul>
                            <p className="mt-4 font-semibold text-blue-800">
                                Strict Quality Control: Only merchants who have government permits, provide high-quality products/services, and can prove their quality with evidence are registered on this platform.
                            </p>
                        </div>

                        {/* Location Based Search */}
                        <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                            Location-Based Tamil Business Search – Anywhere in the World
                        </h2>
                        <p>
                            When Tamil businesses worldwide register their trade and services on GoodBuyTamizha, the platform utilizes Google Location (Nearby Search) technology. It is designed to prioritize showing registered Tamil businesses located nearest to the user.
                        </p>
                        <div className="grid md:grid-cols-2 gap-6 mt-4">
                            <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
                                <p className="font-medium text-gray-900">For Global Tamils</p>
                                <p className="text-sm mt-2">Tamils living or traveling abroad can easily access Tamil services, products, and business assistance from exactly where they are.</p>
                            </div>
                            <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
                                <p className="font-medium text-gray-900">For Local Residents</p>
                                <p className="text-sm mt-2">Tamils residing in India or other countries can directly contact Tamil merchants in their own local area to fulfill their business requirements.</p>
                            </div>
                        </div>

                        {/* Low Cost Advertising */}
                        <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                            Low-Cost Advertising – For Every Tamil Business
                        </h2>
                        <p>
                            The most unique feature of GoodBuyTamizha is the world's most affordable advertising model: <span className="text-green-600 font-bold text-xl">One Rupee per Hour (₹1/hour).</span>
                        </p>
                        <p>This enables:</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Small & Micro Tamil entrepreneurs.</li>
                            <li>MSME / Udyam registered companies.</li>
                            <li>Large corporate houses.</li>
                        </ul>
                        <p>
                            ...to grow their business in any country without commissions, without middlemen, and through direct contact.
                        </p>

                        {/* Core Values */}
                        <div className="mt-12">
                            <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">
                                Our Core Values
                            </h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-center">
                                {['Verified Tamil Merchants Only', 'No Commission | Direct Business Contact', 'Location-Based Global Search', 'B2B & B2C Business Support', 'Global Tamil Economic Growth'].map((value, index) => (
                                    <div key={index} className="bg-white p-4 roundedshadow-sm border border-gray-100 flex items-center justify-center h-full">
                                        <span className="font-medium text-blue-700">{value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Conclusion */}
                        <div className="mt-12 text-center border-t border-gray-200 pt-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                GoodBuyTamizha – More Than an E-Commerce Platform
                            </h2>
                            <p className="mb-6">
                                GoodBuyTamizha is not just an ordinary e-commerce site. It is a reliable Global Tamil Business Ecosystem for every entrepreneur and consumer looking to trade across the world.
                            </p>
                            <p className="text-xl font-bold text-blue-800 italic">
                                "Global Tamil Business – For Tamils, By Tamils, On a Single Platform."
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
